<template>
  <div style="overflow: hidden;" @click="$root.activeMobileMenu=false">
    <v-toolbar style="background-color:#3A2D01; height: 200px;">
      <v-toolbar-title>
        <Logo></Logo>
    </v-toolbar-title>
    </v-toolbar>
    <v-navigation-drawer permanent right class="submenu" style="overflow: hidden;">
      <v-list class="listScroll">
        <v-list-tile :class="['subMenuItem', $root.activePage == item.page ? 'active' : '']" v-for="item in menu" v-if="canRead(item)" :key="item" @click.native="menuClick(item)">
          <v-list-tile-action>
            <i class="material-icons icon">{{ item.icon }}</i>
          </v-list-tile-action>
          <v-list-tile-content v-if="$root.isRTL">
            <v-list-tile-title style="text-align: right!important; margin: 10px;">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="showBadge(item)">
            <div class="w3-badge"><b>{{$root.messagesCounter}}</b></div>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile class="subMenuItem" @click.native="confirmSignout">
          <v-list-tile-action>
            <i class="material-icons icon">lock</i>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title style="text-align: right!important; margin: 10px;">יציאה</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import Logo from '../components/Logo';
  import { db, auth } from '../firebase';

  export default {
    name: 'subMenu',
    components: { Logo },
    data() {
      return {
        menu: [
          //{ title: "היומנים שלי", icon: 'assignment', page: 'MyDiaries', adminOnly: false, customerOnly: true, userOnly: true },
          { title: "יומנים", icon: 'assignment', page: 'Diaries', adminOnly: true, customerOnly: true, userOnly: true },
          { title: "פרויקטים", icon: 'business_center', page: 'Projects', adminOnly: true, customerOnly: true, userOnly: false },
          { title: "תוכניות בנייה", icon: 'picture_as_pdf', page: 'Plans', adminOnly: true, customerOnly: true, userOnly: false },
          { title: "לקוחות", icon: 'recent_actors', page: 'Customers', adminOnly: true, customerOnly: false, userOnly: false },
          { title: "מנהלי עבודה", icon: 'streetview', page: 'Contractors', adminOnly: true, customerOnly: true, userOnly: false },
          { title: "מפקחים", icon: 'record_voice_over', page: 'Inspectors', adminOnly: true, customerOnly: true, userOnly: false },
          { title: "משקיפים", icon: 'remove_red_eye', page: 'Observers', adminOnly: true, customerOnly: true, userOnly: false },
          { title: "יזמים", icon: 'local_atm', page: 'Entrepreneurs', adminOnly: true, customerOnly: false, userOnly: false },
          { title: "משתמשים", icon: 'group', page: 'Users', adminOnly: true, customerOnly: false, userOnly: false },
          { title: "דוחות", icon: 'equalizer', page: 'Reports', adminOnly: true, customerOnly: false, userOnly: false },
          { title: "הודעות", icon: 'chat', page: 'Messages', adminOnly: false, customerOnly: false, userOnly: true },
          { title: "הגדרות חשבון", icon: 'person', page: 'MyAccount', adminOnly: false, customerOnly: true, userOnly: true },
          { title: "הגדרות", icon: 'settings', page: 'Settings', adminOnly: true, customerOnly: false, userOnly: false }, 
          //{ title: "יציאה", icon: 'lock', page: 'Logout', adminOnly: true, customerOnly: true, userOnly: true }
        ]
      }
    },
    created() {
      this.$Log("Vue [subMenu] is created ...");
    },
    ready() {
      this.$Log("Vue [subMenu] is ready ...");
    },
    mounted() {
      this.$Log("Vue [subMenu] is mounted ...");
    },
    updated() {
      this.$Log("Vue [subMenu] is updated ...");
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'Logout') {
          this.$root.logout();
        }
      }
    },
    methods: {
      showBadge(item) {
        if (item.page == 'Messages') {
          return (this.$root.messagesCounter > 0);
        }
        else {
          return false;
        }
      },
      canRead(item) {
        if (this.$root.user) {
          if (this.$root.user.Type === 'מנהל מערכת') {
            return item.adminOnly;
          }
          else if (this.$root.user.Type == 'רוכש') {
            return item.customerOnly;
          }
          else {
            return item.userOnly;
          }
        }
        else {
          return item.userOnly;
        }
      },
      menuClick(item) {
        this.$Log("Clicked item  >>> " + JSON.stringify(item));
        this.$router.push({ name: item.page });
      },
      confirmSignout() {
        this.$root.confirm = {
          isVisible: true,
          title: 'יציאה',
          question: 'האם אתה בטוח ברצונך לצאת מהמערכת?',
          caller: 'Logout',
          isConfirmed: false
        }
      }
    }
  }

</script>

<style>
  .listScroll {
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }


  .w3-badge {
    position: relative;
    display: block;
    width: 22px;
    height: 22px;
    background-color: red;
  }

    .w3-badge > b {
      position: absolute;
      left: 0;
      display: block;
      text-align: center !important;
      width: 22px;
      font-size: 16px;
    }

  ::-webkit-scrollbar {
    display: none;
  }

  .sidebar--open {
    width: 250px !important;
  }

  .router-link-active a {
    background-color: #ffc400 !important;
  }

  .navigation-drawer {
    /*width: 300px !important;*/
    width: 250px !important;
  }

  .logoSmall {
    width: 120px;
    height: 120px;
    margin-top: 15px;
    margin-left: 30px;
    cursor: pointer;
  }

  .logoSmallRTL {
    width: 120px;
    margin-top: 15px;
    margin-right: 30px;
    cursor: pointer;
    float: right;
  }

  .titleLTR {
    margin-left: -200px !important;
    text-align: left !important;
  }

  .titleRTL {
    margin-right: -180px;
    text-align: right !important;
  }
  
  .lblVer {
    position: absolute;
    font-size: 12px;
  }
  
  .toolbar__title {
    margin-left: 0px;
    letter-spacing: 0px;
  }

  .toolbar__content, .toolbar__extension {
    display: contents !important;
  }
  
  .navigation-drawer > .list:not(.list--dense) .list__tile {
    height: 60px !important;
  }

  .list > li {
    height: 60px !important;
  }

  .list a.list__tile {
    height: 60px !important;
  }

  .list > li {
    height: 70px;
    border-bottom: 1px solid #ccc;
  }

    .list > li :hover {
      background-color: #efefef;
    }

    .list > li > a {
      height: 70px;
    }

      .list > li > a > div > i.icon {
        font-size: 35px;
        color: #3A2D01 !important;
      }


    .subMenuItem > a {
      color: #3A2D01 !important;
    }

  .active {
    border-right: 10px #F7941D solid;
  }
</style>



// WEBPACK FOOTER //
// SubMenu.vue?3794cb44